import emptyFunction from "@jnctn/core/utilities/emptyFunction";
import { createContext, type SetStateAction, type Dispatch } from "react";
import type { Location } from "./LocationContextShared";
export { DEFAULT } from "./LocationContextShared";

const LocationContext = createContext<{
  location: Location;
  setLocation: Dispatch<SetStateAction<Location>>;
}>({
  location: undefined,
  setLocation: emptyFunction,
});

export default LocationContext;
